import React, { useState, useEffect } from "react";
import { NAV } from "@/constants/testIds";
import { Menu, X } from "lucide-react";

const LINKS = [
  { slug: "collection", label: "The Collection" },
  { slug: "about", label: "About" },
  { slug: "careers", label: "Careers" },
  { slug: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (slug) => {
    setOpen(false);
    const el = document.getElementById(slug);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F8F6]/85 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="container-wide flex items-center justify-between h-20">
        <button
          data-testid={NAV.logo}
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3 group"
          aria-label="In Stone Supplies — Home"
        >
          <img
            src="/logo.png"
            alt="In Stone Supplies"
            className="h-12 md:h-14 w-auto object-contain transition-opacity group-hover:opacity-80"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.slug}
              data-testid={NAV.link(l.slug)}
              onClick={() => scrollTo(l.slug)}
              className="link-elegant text-sm tracking-wide text-[#1A1A1A] hover:text-[#8C7A6B] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid={NAV.ctaContact}
          onClick={() => scrollTo("contact")}
          className="hidden md:inline-flex items-center justify-center px-6 py-3 bg-[#1A1A1A] text-[#F9F8F6] text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#3a3a3a] transition-colors"
        >
          Visit Showroom
        </button>

        <button
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#1A1A1A]"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F9F8F6] border-t border-black/5">
          <div className="container-wide py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.slug}
                onClick={() => scrollTo(l.slug)}
                className="text-left text-base text-[#1A1A1A] hover:text-[#8C7A6B]"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("contact")}
              className="mt-2 inline-flex items-center justify-center px-6 py-3 bg-[#1A1A1A] text-[#F9F8F6] text-xs tracking-[0.2em] uppercase font-semibold"
            >
              Visit Showroom
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
